import { Fragment } from 'react/jsx-runtime';

import { useGetUsers } from '../hooks';

import { UsersListError } from './UsersListError';
import { UsersListLoading } from './UsersListLoading';
import { UsersTableRow } from './UsersTableRow';
import { UsersListStatus } from './UsersListStatus';

export const UsersList = () => {
  const usersQuery = useGetUsers();

  if (usersQuery.isLoading) return <UsersListLoading />;

  if (!usersQuery.data || !Array.isArray(usersQuery.data.data))
    return <UsersListStatus />;

  if (usersQuery.isError)
    return <UsersListError refetch={usersQuery.refetch} />;

  return (
    <Fragment>
      {usersQuery.data &&
        usersQuery.data.data.map((user, index) => {
          return <UsersTableRow key={index} {...user} />;
        })}
    </Fragment>
  );
};
